// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3E4DB","buttons":"RemoveExpirationActionButtons_buttons__HuaGM"};